import { render } from "./final-gaji-baru.vue?vue&type=template&id=2c7194f2"
import script from "./final-gaji-baru.vue?vue&type=script&lang=js"
export * from "./final-gaji-baru.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__